import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  showText?: boolean;
}

// Placeholder SVG logo - replace the SVG content with your actual logo
function LogoIcon({ className }: { className?: string }) {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 288" className={className}>
    <defs>
      <linearGradient
        id="Gradient_bez_nazwy_3"
        x1={69.7}
        x2={201.39}
        y1={132.03}
        y2={132.03}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.19} stopColor="#e100ff" />
        <stop offset={0.29} stopColor="#c212fc" />
        <stop offset={0.64} stopColor="#5b4ef2" />
        <stop offset={0.89} stopColor="#1974ec" />
        <stop offset={1} stopColor="#0083ea" />
      </linearGradient>
      <linearGradient
        id="Gradient_bez_nazwy_4"
        x1={54.98}
        x2={234}
        y1={196.91}
        y2={196.91}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.17} stopColor="#e100ff" />
        <stop offset={0.28} stopColor="#c212fc" />
        <stop offset={0.63} stopColor="#5b4ef2" />
        <stop offset={0.88} stopColor="#1974ec" />
        <stop offset={1} stopColor="#0083ea" />
      </linearGradient>
      <style>{".cls-2{fill:#fff}"}</style>
    </defs>
    <g
      id="bakerysoft-black_color-notext"
      data-name="bakerysoft-black+color-notext"
    >
      <path d="M148.84 49.5v16.63a17.61 17.61 0 0 1-.27 3.1 17.12 17.12 0 0 1-.81 3 18 18 0 0 1-7.92 9.44 16.09 16.09 0 0 1-2 1l-.37.14-.47.19-.41.15-5.75 2.09-.39.14L109.7 93l-14.24 5.14a9 9 0 0 0 6.16 16.91l3.08 8.46a18 18 0 0 1-12.32-33.84l14.24-5.18 12.65-4.6 7.56-2.76.54-.2 3.47-1.26 2.68-1 .21-.07.19-.06.41-.16a9 9 0 0 0 5.49-8.27V49.5a4.06 4.06 0 0 1 .16-1.16 4 4 0 0 1 .36-.94 4.49 4.49 0 0 1 7.95 0 4 4 0 0 1 .37.94 4.06 4.06 0 0 1 .18 1.16Z" />
      <path
        d="M201.39 133.18a18 18 0 0 1-11.84 16.92l-2.78 1-5.68 2.06-19.92 7.25-3 1.1-5.44 2-3.79 1.38-9 3.28-8.32 3-3.08-8.45 11.4-4.14 9-3.28.71-.26 8.45-3.08 19.9-7.25 7.21-2.63.15-.06 1-.38a9 9 0 0 0-6.16-16.91l-2.78 1-5 1.82-.15.06-.49.18-13.68 5-6.1 2.27-2.78 1-5.68 2.06L76 162.7l-.21.08a4.62 4.62 0 0 1-1.54.27 4.5 4.5 0 0 1-1.54-8.73l.2-.07 67.55-24.58 7.21-2.63.15-.06 1-.38.3-.11 9-3.28 10.6-3.86a9 9 0 0 0-6.16-16.91l-49.46 18-3.03-8.44 29.56-10.76L159.54 94a18 18 0 0 1 23.64 21.23h.21a18 18 0 0 1 18 17.95Z"
        style={{
          fill: "url(#Gradient_bez_nazwy_3)",
        }}
      />
      <path
        d="M176.59 229.79a.29.29 0 0 1 0 .09 1.59 1.59 0 0 1-.07.2Z"
        className="cls-2"
      />
      <path
        d="M176.59 229.79a.29.29 0 0 1 0 .09 1.59 1.59 0 0 1-.07.2Z"
        className="cls-2"
      />
      <path
        d="M234 178.77a18 18 0 0 1-8.58 15.35 18 18 0 0 1-3.25 1.57l-4.48 1.63-.66.24-3.31 1.21-29.78 10.84-7.35 20.16-.1.29a4.5 4.5 0 0 1-8.73-1.54A4.38 4.38 0 0 1 168 227l.08-.21 4.78-13.15-26.72 9.72-.21.08a4.38 4.38 0 0 1-1.54.28 4.5 4.5 0 0 1-1.54-8.73l.2-.07 67.55-24.59 8.45-3.08a9 9 0 0 0-3.05-17.48 8.72 8.72 0 0 0-2.76.44l-.32.1-8.45 3.08.32-.1-11.58 4.21-44.28 16.11-8.08 2.94-.92.33-5.17 1.88-2.23.81-13.37 4.87-.28.1-14.8 5.39-8 2.92L92.9 214l-5.31 1.93-8.45 3.07a18 18 0 0 1-12.32-33.84l8.44-3.08 45-16.36 3.07 8.46-44.98 16.39-8.45 3.08a9 9 0 0 0 6.16 16.91l8.45-3.08 8.49-3.07 7.6-2.76.24-.1.62-.22.45-.16 5.7-2.08 8-2.92 13.83-5 8.32-3 2.16-.79 9-3.28 52.46-19.1 8.44-3.08.23-.08a17 17 0 0 1 3.27-.8A18 18 0 0 1 234 178.77Z"
        style={{
          fill: "url(#Gradient_bez_nazwy_4)",
        }}
      />
      <path d="m213 208.6-14.76 40.56a17.1 17.1 0 0 1-1.33 2.84 18 18 0 0 1-15.59 9h-73.78A18 18 0 0 1 92 252a16.49 16.49 0 0 1-1.28-2.72v-.12l-8-21.85 8.46-3.08 2.6 7.16 1.61 4.61 3.13 8.59.56 1.54a9 9 0 0 0 5.37 5.37 8.72 8.72 0 0 0 3.08.55h73.78a8.72 8.72 0 0 0 3.08-.55 9 9 0 0 0 5.37-5.37L202 212.62Z" />
    </g>
  </svg>
  );
}

const sizeClasses = {
  sm: "h-6 w-6",
  md: "h-8 w-8",
  lg: "h-12 w-12",
  xl: "h-16 w-16",
};

const textSizeClasses = {
  sm: "text-lg",
  md: "text-xl",
  lg: "text-2xl",
  xl: "text-3xl",
};

export function Logo({ className, size = "md", showText = true }: LogoProps) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <LogoIcon className={cn(sizeClasses[size], "text-accent")} />
      {showText && (
        <span
          className={cn(
            "font-semibold tracking-tight text-foreground",
            textSizeClasses[size]
          )}
        >
          Bakerysoft
        </span>
      )}
    </div>
  );
}

// Export the icon separately for use cases where only the icon is needed
export { LogoIcon };
